<a
  routerLink="/services/{{ project.slug }}"
  [class]="isHomePage === true ?  'home-card' : 'service-card' "

  [style]="'background-image: url(' + getUrlImagemDestaque() + ')'"
>
  <span class="title">{{ project.title }}</span>
  <span class="icon"></span>
</a>
